module.exports = __webpack_public_path__ + "img/mdi--dots-horizontal.4d3690e9.svg";